<template>
  <v-container fluid pa-3 background>
    <!-- Form -->
    <v-layout row wrap v-show="!showLoading">
      <v-flex md12 sm12 xs12 pa-3 style="background-color:#fff; border-radius:5px;">
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md6 sm6 xs12 text-xs-center class="hidden-sm-and-up">
                <v-avatar
                  size="256"
                  :tile="true"
                  @click="
                    '';

                  "
                >
                  <v-icon size="256" color="black" style="cursor: pointer;">fa-image</v-icon>
                  <img src="''" alt="alt" style="display: none;" />
                </v-avatar>
              </v-flex>
              <v-flex md6 sm6 xs12>
                <v-layout row wrap>
                  <v-flex xs12 pa-1>
                    <v-text-field :label="$t('CompanyName')" v-model="address_setting.companyname" hide-details />
                  </v-flex>
                  <v-flex x12 pa-1>
                    <v-text-field label="เลขที่ผู้เสียภาษี" v-model="address_setting.taxpayer_number" hide-details />
                  </v-flex>
                     <v-flex x12 pa-1>
                    <v-text-field label="เลขที่บัญชีนายจ้าง" v-model="address_setting.acc_no" max="10" hide-details />
                  </v-flex>
                  <v-flex xs12 style="margin-top:15px;">
                    <h3>{{ $t("Address") }}</h3>
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('Building')" v-model="address_setting.building" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('Room_No')" v-model="address_setting.room_no" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('Floor')" v-model="address_setting.floor" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('Village')" v-model="address_setting.village" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('House_No')" v-model="address_setting.house_no" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('Village_No')" v-model="address_setting.village_no" hide-details />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md6 sm6 xs12 text-xs-center class="hidden-xs-only">
                <v-avatar size="256" :tile="false" @click="uploadPic()">
                  <v-icon size="256" color="black" style="cursor: pointer;" v-if="img == ''">fa-image</v-icon>
                  <img v-if="img != ''" :src="img" />
                  <input type="file" id="file1" name="image" ref="file1" class="upload" @change="onChangePicture($event, 1)" accept="image/*" capture style="display:none" />
                </v-avatar>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md6 sm6 x12 pa-1>
                <v-text-field :label="$t('Alley_Lane')" v-model="address_setting.alley_lane" hide-details />
              </v-flex>
              <v-flex md6 sm6 x12 pa-1>
                <v-text-field :label="$t('Road')" v-model="address_setting.road" hide-details />
              </v-flex>

              <v-flex md6 sm6 x12 pa-1>
                <v-text-field :label="$t('SubDistrict_SubArea')" v-model="address_setting.subdistrict_subarea" hide-details />
              </v-flex>
              <v-flex md6 sm6 x12 pa-1>
                <v-text-field :label="$t('District_Area')" v-model="address_setting.district_area" hide-details />
              </v-flex>
              <v-flex md6 sm6 x12 pa-1>
                <v-text-field :label="$t('Province')" v-model="address_setting.province" hide-details />
              </v-flex>
              <v-flex md6 sm6 x12 pa-1>
                <v-text-field :label="$t('Zipcode')" v-model="address_setting.postcode" hide-details />
              </v-flex>
              <v-flex md6 sm6 x12 pa-1>
                <v-text-field :label="$t('TelephoneNumber')" v-model="address_setting.telephone1" hide-details />
              </v-flex>

              <v-flex xs12 style="padding-top: 12px;">
                <h3>Social Media</h3>
                <v-layout row wrap px-2>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field label="LINE ID" v-model="address_setting.line_id" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 xs12 pa-1>
                    <v-text-field label="FACEBOOK" v-model="address_setting.facebook" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field label="TWITTER" v-model="address_setting.twitter" hide-details />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 text-xs-right pa-3 v-if="permission_edit == true || admin == 'true'">
            <v-btn color="success" @click="address_setting.length == 0 ? onSave() : onUpdate()">
              <v-icon>save</v-icon>
              <span class="px-2">{{ address_setting.length == 0 ? $t("create") : $t("save") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
/* jshint ignore:start */
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import SettingService from "@/services/SettingService";
import UserService from "@/services/UserService";
export default {
  data: () => ({
    img: "",
    address_setting: {
      roworder: 0,
      address: "",
      companyname: "",
      building: "", //อาคาร
      room_no: "", //ห้อง
      floor: "", //ชั้น
      village: "", //หมู่บ้าน
      house_no: "", //บ้านเลขที่
      village_no: "", //หมู่ที่
      alley_lane: "", //ตรอก/ซอย
      road: "", //ถนน
      subdistrict_subarea: "", //ตำบล/แขวง
      district_area: "", //อำเภอ/เขต
      province: "", //จังหวัด
      postcode: "", //รหัสไปรษณีย์
      telephone1: "",
      telephone2: "",
      code: "000-1",
      editor_code: "",
      imageLogo: "",
      taxpayer_number: "",
      line_id: "",
      facebook: "",
      twitter: "",
      acc_no: "",
      company_id: localStorage._company_guid,
    },
    permission_edit: false,
    permission_view: false,
    admin: false,
    empCode: localStorage._empcode,
    permission: [],
  }),
  created: async function() {
    this.admin = localStorage._is_admin;
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("CompanyAddress");
    console.log(this.check_permission);
    this.commitSetToolbar({ patternTool: "2" });
    this.getCompanyAddress();
  },
  destroyed: function() {
    this.commitToggleAlertDialog({ status: false, message: Object });
  },
  computed: {
    ...mapState("app", ["showLoading"]),
    ...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    getCompanyAddress() {
      this.commitSetShowLoading(true);
      SettingService.getCompanyAddress()
        .then((res) => {
          if (res.data.content.length > 0) {
            this.address_setting = res.data.content[0];
            if (this.address_setting.imageLogo != "" && this.address_setting.imageLogo != null && this.address_setting.imageLogo != undefined) {
              this.img = this.address_setting.imageLogo;
            }
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    uploadPic($event) {
      const elem = this.$refs.file1;
      elem.click();
    },
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    onSave() {
      this.address_setting.imageLogo = "";
      if (this.img != "") {
        var rep_img1 = this.img.replace("data:image/png;base64,", "");
        var rep_img2 = rep_img1.replace("data:image/gif;base64,", "");
        var rep_img3 = rep_img2.replace("data:image/jpg;base64,", "");
        var rep_img4 = rep_img3.replace("data:image/bmp;base64,", "");
        var rep_img5 = rep_img4.replace("data:image/jpeg;base64,", "");

        this.address_setting.imageLogo = rep_img5;
      }
      this.commitSetShowLoading(true);

      this.address_setting.company_id = localStorage._company_guid;
      SettingService.saveCompanyAddress(this.address_setting)
        .then((res) => {
          this.getCompanyAddress();
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(true);
        });
    },
    onUpdate() {
      this.address_setting.imageLogo = "";
      if (this.img != "") {
        var rep_img1 = this.img.replace("data:image/png;base64,", "");
        var rep_img2 = rep_img1.replace("data:image/gif;base64,", "");
        var rep_img3 = rep_img2.replace("data:image/jpg;base64,", "");
        var rep_img4 = rep_img3.replace("data:image/bmp;base64,", "");
        var rep_img5 = rep_img4.replace("data:image/jpeg;base64,", "");

        this.address_setting.imageLogo = rep_img5;
      }
      this.address_setting.company_id = localStorage._company_guid;
      this.commitSetShowLoading(true);
      SettingService.updateCompanyAddress(this.address_setting)
        .then((res) => {
          this.getCompanyAddress();
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(true);
        });
    },
    onChangePicture($event, index) {
      this.readThisdata($event.target, index);
    },
    readThisdata(inputValue, index) {
      const file = inputValue.files[0];
      const myReader = new FileReader();
      myReader.onloadend = (e) => {
        this.img = myReader.result;
      };
      myReader.readAsDataURL(file);
    },
  },
};
</script>
